import { render, staticRenderFns } from "./PhotosRegister.vue?vue&type=template&id=f5707730&scoped=true&"
import script from "./PhotosRegister.vue?vue&type=script&lang=js&"
export * from "./PhotosRegister.vue?vue&type=script&lang=js&"
import style0 from "./PhotosRegister.vue?vue&type=style&index=0&id=f5707730&prod&scoped=true&lang=css&"
import style1 from "./PhotosRegister.vue?vue&type=style&index=1&id=f5707730&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5707730",
  null
  
)

export default component.exports